var StremioVideo = require('./StremioVideo');

module.exports = StremioVideo;
